/**
 * The flow of ลมปราณ (qi) beyond plain regeneration (numbers: data/qi.ts). Out of a fight the
 * bar refills fast (faster still while meditating), and in a fight the triangle feeds it: a basic
 * cut that lands and a blow caught on the guard give qi back. The player's alone: monsters' moves
 * cost no qi and opponents are refilled by world.ts.
 */
import { QI } from '../data/qi';
import type { WorldEvent } from '../world';
import type { SystemHost, WorldSystem } from './types';

export class QiFlowSystem implements WorldSystem {
  readonly name = 'qiFlow';

  constructor(private readonly h: SystemHost) {}

  playerStep(dt: number): void {
    const p = this.h.world.player;
    if (p.combatT > 0 || p.qi >= p.maxQi) return;
    const share = QI.outOfCombatPerSec + (p.meditating ? QI.meditatePerSec : 0);
    p.qi = Math.min(p.maxQi, p.qi + p.maxQi * share * dt);
  }

  observe(e: WorldEvent): void {
    if (e.type !== 'hit') return;
    const p = this.h.world.player;
    if (p.dead) return;
    let gain = 0;
    if (e.srcId === p.id && e.skillId === 'basic')
      gain = e.outcome === 'hit' || e.outcome === 'interrupt' || e.outcome === 'guardBreak' ? QI.perBasicHit : 0;
    else if (e.tgtId === p.id && e.outcome === 'blocked') gain = QI.perBlock;
    if (gain) p.qi = Math.min(p.maxQi, p.qi + gain);
  }
}
